var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncreaseDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9.857,
    height: 9.847,
    viewBox: "0 0 9.857 9.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.847,
    height: 9.857,
    transform: "translate(0 0)",
    fill: "#042848"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.857) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.347,8.125a.5.5,0,0,1-.5-.5V1H2.222a.5.5,0,0,1,0-1H9.347a.5.5,0,0,1,.5.5V7.625a.5.5,0,0,1-.5.5",
    fill: "#042848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5,9.857A.5.5,0,0,1,.146,9L8.993.146A.5.5,0,0,1,9.7.853L.854,9.711A.5.5,0,0,1,.5,9.857",
    fill: "#042848"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseDown);
export default __webpack_public_path__ + "static/media/increaseDown.1da787672eaff6b129a0c9fe47f783bf.svg";
export { ForwardRef as ReactComponent };